<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>棋招管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.sectId" placeholder="请选择棋派" filterable style="width:180px">
					<el-option key="" label="请选择棋派" value=""></el-option>
					<el-option v-for="item in chessSectKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-cascader  placeholder="请选择棋子"
					:options="productOptions"
					v-model="productInfo" filterable clearable>
				</el-cascader> &nbsp;
				<el-select v-model="query.demandType" placeholder="请选择需求类型" filterable style="width:180px">
					<el-option key="" label="请选择需求类型" value=""></el-option>
					<el-option v-for="item in demandTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="sectName" label="棋派"></el-table-column>
				<el-table-column prop="typeSeriesRemark" label="系列" width="200"></el-table-column>
				<el-table-column prop="productName" label="棋子" width="150"></el-table-column>
				<el-table-column prop="demandType" label="类型" :formatter=demandTypeFormat width="80"></el-table-column>
				<el-table-column prop="demandTimes" label="次数" width="80"></el-table-column>
				<el-table-column prop="demandNum" label="数量" width="80"></el-table-column>
				<el-table-column prop="demandPrice" label="价格区间" width="160">
					<template slot-scope="scope">
                        {{(scope.row.minPrice&&scope.row.maxPrice)?"￥"+scope.row.minPrice + "-￥" + scope.row.maxPrice:(scope.row.minPrice?scope.row.minPrice:scope.row.maxPrice)}}
                    </template>
				</el-table-column>
				<el-table-column prop="updateTime" label="更新时间" width="160"></el-table-column>
                <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                        <router-link  :to="{path:'/chess-demand-record',query:{id:scope.row.id, type:scope.row.demandType, name:scope.row.productName,sectId:scope.row.sectId,productId:scope.row.productId}}"><el-button
                            type="text"
                            icon="el-icon-link"
							v-if="controll['chess-demand-record'] && (scope.row.demandType==0||scope.row.demandType==2||scope.row.demandType==5||scope.row.demandType==6)"
                        >记录</el-button></router-link>&nbsp;
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-refresh"
                    class="handle-del mr10"
                    @click="handleAnalysis"
					v-if="controll['analysis']"
                >棋招解析</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="棋派" prop="sectId">
                    <el-select v-model="form.sectId" placeholder="请选择棋派" filterable>
						<el-option key="" label="请选择棋派" value=""></el-option>
						<el-option v-for="item in chessSectKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="棋子" prop="productInfo">
                    <el-cascader 
						:options="productOptions"
						v-model="form.productInfo" filterable>
					</el-cascader>
                </el-form-item>
				<el-form-item label="需求类型" prop="demandType">
                    <el-select v-model="form.demandType" placeholder="需求类型" filterable>
						<el-option key="" label="请选择需求类型" value=""></el-option>
						<el-option v-for="item in demandTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="需求数量" prop="demandNum"  style="width:310px">
                    <el-input v-model="form.demandNum"></el-input>
                </el-form-item>
				<el-form-item label="需求价格区间" prop="price">
                    <el-input v-model="form.minPrice"  style="width:100px"></el-input> - <el-input v-model="form.maxPrice" style="width:100px"></el-input>
                </el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<v-Analysis ref="child"></v-Analysis>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import vAnalysis from '../../common/Analysis.vue';
import { fetchChessDemandData, saveChessDemand, deleteChessDemand, getChessDemand, getChessSectKV, getAllProducts, getChessRegular, getChessRegularKV, getEnumByCode } from '../../../api/index';
export default {
    name: 'chess-demand',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
			multipleSelectionAnalysis:[],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                sectId: [{ required: true, message: '棋派不能为空', trigger: 'blur' }],
				productInfo: [{ required: true, message: '棋子不能为空', trigger: 'blur' }],
				demandType: [{ required: true, message: '需求类型不能为空', trigger: 'blur' }]
            },	demandTypeKV:[{"key":0,"value":"询价"},{"key":1,"value":"常用"},{"key":2,"value":"买过"},{"key":3,"value":"常备"},{"key":4,"value":"不备货"},{"key":5,"value":"报价"}],
			chessSectKV:[],
			productOptions:[],
			productInfo:[],
			resultData:[],
			rowBackUp:{},
			analysis:{},
			currentRegular:{},
			analysisVisible:false,
			editEnable:false,
			scrollTop:0,
			demandTypeCode:1022,
			demandTypeDatas:[],
			demandTypeRegular:"(?<demandType>%s)",
			currentDemandType:"",
			sourceVisible:true,
			leftColSize:10,
			rightColSize:14,
			currentSourceId:"",
			currentRegularType:2,
			isSupportReplay:true,
			progressAge:0,
			progressMax:0,
			submitResultData:[],
			quantityPerTime:80,
			submitIndex:0,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("chess-demand");
		this.getChessSects();
		this.getProducts();
        this.getData();
    },
	components: {
        vAnalysis
    },
    methods: {
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//类型匹配
		demandTypeFormat(row, column, cellValue) {
			let statusConfig = {"0":"询价", "1":"常用", "2":"买过","3":"常备","4":"不备货","5":"报价"};
			return statusConfig[cellValue];
		},
		//获取产品信息
		getProducts() {
			getAllProducts().then(res => {
				if (res.code == 0) {
					this.productOptions = res.data;
				} else {
					this.$message.error(`获取产品信息失败！` + res.message);
				}
			})
		},
		//获取棋派
		getChessSects() {
			getChessSectKV().then(res => {
				if (res.code == 0) {
					this.chessSectKV = res.data;
				} else {
					this.$message.error(`获取棋派信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
			if (this.productInfo.length == 3) {
			    this.query["productId"] = this.productInfo[2];
			}
            fetchChessDemandData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChessDemand([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChessDemand(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
		handleAnalysis() {
			this.analysis = {};
			this.resultData = [];
			this.analysisVisible = true;
			let lineobj = document.getElementById("leftNum");
			if (lineobj) {
				lineobj.value = "";
			}
			this.$refs.child.setAnalysisData(undefined, "demand", undefined, undefined);
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.form["productInfo"]) {
						this.form["productId"] = this.form["productInfo"][2];
					}
					delete this.form["productInfo"];
					saveChessDemand(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.edit-container {
  height: 570px;
  padding: 10px 20px;
}

.edit {
  display: flex;
  height: 530px;
}

.leftBox {
  width: 45px;
  height: 100%;
  text-align: left;
}

.area-content {
  padding: 10px 8px;
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 24px;
  color: #2dc26b;
  font-family: Consolas;
  border: none;
  background: #373737;
  box-sizing: border-box;
  outline: none;
  resize: none;
}

#leftNum {
  padding: 10px 4px;
  height: 100%;
  width: 100%;
  line-height: 24px;
  font-size: 13px;
  text-align: right;
  color: #fff;
  font-weight: bold;
  resize: none;
  outline: none;
  border: 0;
  background: black;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:600px;
	width:10px;
	position:absolute;
	margin-left:-15px;
	text-align:center;
	line-height:600px;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}
</style>
